import { FC, useCallback, useRef } from 'react';
import { AllieSelect } from './Select';
import { AllieSelectProps } from './Select.types';

export const OptimizedSelect: FC<AllieSelectProps> = ({ onChange, ...props }) => {
  const isChanging = useRef(false);

  const handleChange = useCallback((e: any) => {
    if (isChanging.current) return;
    
    isChanging.current = true;
    onChange?.(e);

    setTimeout(() => {
      isChanging.current = false;
    }, 0);
  }, [onChange]);

  return <AllieSelect {...props} onChange={handleChange} />;
}; 
